import styles from "./Login.module.scss";
import { Input } from "../../components/Input/Input";
import { useContext } from "react";
import { ContainedBtn } from "../../components/ButtonTypes/Button";
import { AlignCenter, AlignRight } from "../../components/Box/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faKey,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { AuthContext } from "../../services/Auth";
import { Navigate } from "react-router-dom";

function Login() {
  const { login, authenticated, form, setForm } = useContext(AuthContext);

  if (authenticated) return <Navigate to="/sgr" />;

  return (
    <>
      <AlignCenter>
        <h1 className={styles.title}>Login</h1>
      </AlignCenter>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login(form);
        }}
      >
        <section className={styles.section}>
          <Input
            className={styles.input}
            icon={<FontAwesomeIcon icon={faUser} />}
            label="E-mail"
            type="email"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            value={form.email}
            required
          />
        </section>

        <section className={styles.section}>
          <Input
            className={styles.input}
            icon={<FontAwesomeIcon icon={faKey} />}
            label="Senha"
            type="password"
            onChange={(e) => setForm({ ...form, senha: e.target.value })}
            value={form.senha}
            required
            subText={
              <AlignRight>
                <Link to="/esqueci" className={styles.subText}>
                  <FontAwesomeIcon icon={faTriangleExclamation} /> Esqueci minha
                  senha
                </Link>
              </AlignRight>
            }
          />
        </section>

        <section className={styles.section}>
          <AlignRight>
            <ContainedBtn className={styles.submitBtn}>Entrar</ContainedBtn>
          </AlignRight>
        </section>
      </form>
    </>
  );
}

export default Login;
